module.exports = __webpack_public_path__ + "static/media/daily_mail_logo.de97e678.svg";